import React, { useState, useEffect, use } from 'react'
import { getWhatsappTemplatesList, deleteWhatsappTemplateById, getWhatsappTemplateSearchBySubjectKeyword, SaveWhatsappTemplateByData, UpdateWhatsappTemplateByData, TestWhatsappTemplate } from "../ActionCreator";
import Multiselect from "multiselect-react-dropdown";
import ReactQuill from "react-quill";
import ConfirmationPopup from "../../../../presentationals/Popup/ConfirmationPopup.component";
import NodataImage from '../../../../../images/nodata.png'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AddIcon from '@mui/icons-material/Add';
import Popup from '../../../../presentationals/Popup/Popup.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { COMPANY_NAME } from '../../../../../utils/api-factory';
import { formatDateNew } from '../../../../../utils/commonUtility';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import styled from "@emotion/styled";
import InfoIcon from '@mui/icons-material/Info';
import Pagination from '@mui/material/Pagination';

const itemsPerPage = 10;

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: '1.4rem', // Adjust the font size as needed
    },
}));


const quillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        ["blockquote"],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
        ],
        [{ align: [] }],
        ["link", "image"],
    ],
};

const quillFormats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "background",
    "align",
];

const customPalceholder = {
    "1": "user",
    "2": "esignLink",
    "3": "enachLink",
    "4": "amount",
    "5": "date",
    "6": "paymentLink",
    "7": "feedbackLink",
}

const Email = ({ admin }) => {
    const [loader, setLoader] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [viewType, setViewType] = useState("list")
    const [showModal, setshowModal] = useState(false)
    const [editData, setEditData] = useState({})
    const [list, setList] = useState([])
    const [listTableData, setlistTableData] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [deleteData, setDeleteData] = useState({})
    const [TestTemplate, setTestTemplate] = useState({ show: false, data: {} })
    const [TemplateObj, setTemplateObj] = useState({})
    const [objectData, setObjectData] = useState({
        whatsappSubject: "",
        whatsappDescription: "",
        whatsappText: "",
        dltId: "",
        async: false,
        messageType: "",
        media: false,
        attachment: false,
        messageType: "",
        receiverType: "",
        mediaPath: "",
        mediaType: "",
        attachmentUrl: "",
    })

    useEffect(() => {
        getWhatsappTemplatesListFn()
    }, []);

    const handlePage = (type, data) => {
        setViewType(type)
        if (type == "add") {
            setEditData(data)
            setObjectData({
                whatsappSubject: data?.whatsappSubject || "",
                dltId: data?.dltId || "",
                async: data?.async || false,
                whatsappText: data?.whatsappText || "",
                whatsappDescription: data?.whatsappDescription || "",
                messageType: data?.whatsappDescription || "",
                media: data?.media || "",
                attachment: data?.attachment || "",
                messageType: data?.messageType || "",
                receiverType: data?.receiverType || "",
                mediaPath: data?.mediaPath || "",
                mediaType: data?.mediaType || "",
                attachmentUrl: data?.attachmentUrl || "",
            })
        } else if (type == "list") {
            getWhatsappTemplatesListFn()
            setEditData({})
            setObjectData({
                whatsappText: "",
                whatsappSubject: "",
                whatsappDescription: "",
                dltId: "",
                async: false,
                messageType: "",
                media: false,
                attachment: false,
                messageType: "",
                receiverType: "",
                mediaPath: "",
                mediaType: "",
                attachmentUrl: "",
            })
        }
    }

    const cancelLoanConfirm = (type) => {
        if (type == "yes") {
            deleteWhatsappTemplateByIdFn(deleteData?.whatsappId)
            setshowModal(false)
        } else if (type == "no") {
            setshowModal(false)
            setDeleteData({})
        }
    }

    const handleDelete = (data) => {
        setDeleteData(data)
        setshowModal(true)
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleSearchbtn = (e) => {
        if (e.key == "Enter" && searchValue?.length > 0) {
            getWhatsappTemplateSearchBySubjectKeywordFn()
        }
    }

    const changeSearchValue = (e) => {
        setSearchValue(e.target.value)
        if (e.target.value == "") {
            getWhatsappTemplatesListFn()
        }
    }

    const handleAddchange = (e, type) => {
        setObjectData((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handlePalceHolder = (value) => {
        const matches = value.match(/{{(.*?)}}/g);
        if (!matches) return "";

        const result = matches && matches?.length > 0 ? matches?.map(match => match?.replace(/{{|}}/g, '')).join(',') : "";
        return result;
    }

    const handleSave = (e) => {
        const placeholderValue = handlePalceHolder(objectData?.whatsappText)
        if (objectData?.dltId === "" || objectData?.dltId === null || objectData?.dltId === undefined) {
            setPopup({ show: true, popupStatus: "Please Select a Template" })
            removePopup()
        } else if (objectData?.whatsappSubject === "" || objectData?.whatsappSubject === null || objectData?.whatsappSubject === undefined) {
            setPopup({ show: true, popupStatus: "Subject Field is Required" })
            removePopup()
        } else if (objectData?.media === true && ((objectData?.mediaPath === null || objectData?.mediaPath === undefined || objectData?.mediaPath === "") || (objectData?.mediaType === undefined || objectData?.mediaType === null || objectData?.mediaType === ""))) {
            setPopup({ show: true, popupStatus: "Header Path & Type is Required" })
            removePopup()
        } else if (objectData?.attachment === true && ((objectData?.attachmentUrl === null || objectData?.attachmentUrl === undefined || objectData?.attachmentUrl === ""))) {
            setPopup({ show: true, popupStatus: "Attachement URL is Required" })
            removePopup()
        } else if (editData?.whatsappId) {


            // update Fn
            const obj = {
                "whatsappSubject": objectData?.whatsappSubject,
                "whatsappText": objectData?.whatsappText,
                "whatsappDescription": objectData?.whatsappDescription,
                "dltId": objectData?.dltId,
                "async": objectData?.async || false,
                "attachment": false,
                "companyName": COMPANY_NAME,
                "placeholders": placeholderValue,
                messageType: objectData?.messageType,
                media: objectData?.media,
                attachment: objectData?.attachment,
                messageType: objectData?.messageType,
                receiverType: objectData?.receiverType,
                mediaPath: objectData?.mediaPath,
                mediaType: objectData?.mediaType,
                attachmentUrl: objectData?.attachmentUrl,
            }
            UpdateWhatsappTemplateByDataFn(editData?.whatsappId, obj)

        } else {
            const obj = {
                "whatsappText": objectData?.whatsappText,
                "whatsappSubject": objectData?.whatsappSubject,
                "whatsappDescription": objectData?.whatsappDescription,
                "dltId": objectData?.dltId,
                "async": objectData?.async || false,
                "attachment": false,
                "media": false,
                "mediaPath": null,
                "companyName": COMPANY_NAME,
                "placeholders": placeholderValue,
                messageType: objectData?.messageType,
                media: objectData?.media,
                attachment: objectData?.attachment,
                messageType: objectData?.messageType,
                receiverType: objectData?.receiverType,
                mediaPath: objectData?.mediaPath,
                mediaType: objectData?.mediaType,
                attachmentUrl: objectData?.attachmentUrl,
            }
            SaveWhatsappTemplateByDataFn(obj)
        }
    }

    const handlePagePagination = (event, value) => {
        setcurrentPage(value);
        const data = filterFunction(listTableData, value)
        setList(data)
    };

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        return currentItems
    }


    const getWhatsappTemplatesListFn = () => {
        setLoader(true)
        getWhatsappTemplatesList("", callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
                const responseData = callback?.data || [];
                setlistTableData(responseData)
                const data = filterFunction(responseData, 1)
                setList(data)
            } else {
                setList([])
            }
        })
    }

    const deleteWhatsappTemplateByIdFn = (id) => {
        setLoader(true)
        deleteWhatsappTemplateById(id, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Template Deleted Successfully" })
                getWhatsappTemplatesListFn()
                setDeleteData({})
            } else {
                setPopup({ show: true, popupStatus: "Error Deleting Template" })
                setDeleteData({})
            }
            removePopup()
        })
    }

    const getWhatsappTemplateSearchBySubjectKeywordFn = () => {
        setLoader(true)
        getWhatsappTemplateSearchBySubjectKeyword(searchValue, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
                const responseData = callback?.data || [];
                setlistTableData(responseData)
                const data = filterFunction(responseData, 1)
                setList(data)
            } else {
                setList([])
            }
        })
    }

    const SaveWhatsappTemplateByDataFn = (data) => {
        setLoader(true)
        console.log("data", data)
        SaveWhatsappTemplateByData(data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data == "DLT ID already exists") {
                setPopup({ show: true, popupStatus: "DLT ID already exists" })
            } else if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Saved Successfully" })
                setObjectData({
                    whatsappSubject: "",
                    whatsappDescription: "",
                    whatsappText: "",
                    dltId: "",
                    async: false,
                    messageType: "",
                    media: false,
                    attachment: false,
                    messageType: "",
                    receiverType: "",
                    mediaPath: "",
                    mediaType: "",
                    attachmentUrl: "",
                })
            } else {
                setPopup({ show: true, popupStatus: "Error Saving Data" })
            }
            removePopup()
        })
    }
    const UpdateWhatsappTemplateByDataFn = (id, data) => {
        setLoader(true)
        UpdateWhatsappTemplateByData(id, data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data == "DLT ID already exists") {
                setPopup({ show: true, popupStatus: "DLT ID already exists" })
            } else if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Updated Successfully" })
                setObjectData({
                    whatsappSubject: "",
                    whatsappDescription: "",
                    whatsappText: "",
                    dltId: "",
                    async: false,
                    messageType: "",
                    media: false,
                    attachment: false,
                    messageType: "",
                    receiverType: "",
                    mediaPath: "",
                    mediaType: "",
                    attachmentUrl: "",
                })
            } else {
                setPopup({ show: true, popupStatus: "Error Updating Data" })
            }
            removePopup()
        })
    }

    const closeTestingPopup = (type, data) => {
        if (type == true) {
            if (data?.whatsappText?.length > 0) {
                const matches = data?.whatsappText.match(/{{(.*?)}}/g);
                if (!matches) {
                    setTemplateObj({ mobileNumber: "" })
                } else {
                    const keys = matches.map(match => match.replace(/{{|}}/g, ''));
                    const obj = Object.fromEntries(keys.map(key => [key, ""]));
                    obj.mobileNumber = ""
                    setTemplateObj(obj);
                }
                setTestTemplate({ show: true, data: data })

            } else {
                setTestTemplate(false)
                setTemplateObj({ show: false, data: "" })
            }

        } else if (type == false) {
            setTestTemplate({ show: false, data: "" })
            setTemplateObj({})
        }
    }


    const handleTemplateObjChnage = (e, type) => {
        setTemplateObj((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const HandleSendTest = () => {

        if (TemplateObj && Object.keys(TemplateObj)?.length > 0) {
            for (let value of Object.keys(TemplateObj)) {
                if (TemplateObj[value] == null || TemplateObj[value] == undefined || TemplateObj[value] == "") {
                    setPopup({ show: true, popupStatus: `${value} is Required` })
                    removePopup()
                    return
                }
            }

            const { mobileNumber, ...restObj } = TemplateObj
            const obj = { ...restObj }
            if (TemplateObj?.emiDate) {
                const newDate = moment(TemplateObj?.emiDate).format("DD-MM-YYYY")
                obj.emiDate = newDate
            }
            setLoader(true)
            TestWhatsappTemplate(mobileNumber, TestTemplate?.data?.whatsappId, obj, callback => {
                setLoader(false)
                console.log(callback)
                if (callback == "success") {
                    setPopup({ show: true, popupStatus: "Message Send successfully" })
                    closeTestingPopup(false, "")
                } else {
                    setPopup({ show: true, popupStatus: "Error Sending Message" })
                }
                removePopup()
            })
        }
    }



    return (
        <>
            <div className="container-fluid marketing-main-css" style={{ margin: '100px 0 40px 0' }}>
                {
                    loader ?
                        <Loader /> : ''
                }
                {showModal ?
                    <ConfirmationPopup cancelLoanConfirm={cancelLoanConfirm} confirmationText={'Are you sure you want to delete this template?'} />
                    : ""}

                {popup?.show ?
                    <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} />
                    : ''}

                <div className="row">
                    <div style={{ display: 'flex', marginBottom: '20px' }}>

                        <button onClick={() => handlePage('list', "")} className="btn" style={{ color: viewType === "list" ? "#fff" : "#000", background: viewType === "list" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex', margin: '0 16px' }}>
                            <FormatListBulletedIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                        <button onClick={() => handlePage('add', "")} className="btn " style={{ color: viewType === "add" ? "#fff" : "#000", background: viewType === "add" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex' }}>
                            <AddIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                    </div>

                    {viewType === 'list' ?
                        <div className="col-sm-12 col-xs-12">
                            <div className="row" style={{ marginTop: '15px' }}>
                                <div className="col-lg-2 col-sm-3 col-xs-4">
                                    <label htmlFor=""><i class="fa fa-search" aria-hidden="true"></i>&nbsp;Search</label>
                                    <input className='form-control' placeholder='Search by Subject' type='search' value={searchValue} onChange={(e) => changeSearchValue(e)} onKeyDown={(e) => handleSearchbtn(e)} />
                                </div>
                            </div>
                            <hr />
                            {list !== '' && list?.length > 0 ?
                                <>
                                    <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '15px' }}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>DLT Id</th>
                                                    <th className='text-center'>Text</th>
                                                    <th className='text-center'>Subject</th>
                                                    <th className='text-center'>Description</th>
                                                    <th className='text-center'>Async</th>
                                                    <th className='text-center'>Added On</th>
                                                    <th className='text-center'>Test</th>
                                                    <th className='text-center'>Edit</th>
                                                    <th className='text-center'>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list && list?.length > 0 ? list?.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{data.dltId}</td>
                                                        <td className='text-center'>{data?.whatsappText}</td>
                                                        <td className='text-center'>{data?.whatsappSubject}</td>
                                                        <td className='text-center'>{data?.whatsappDescription}</td>
                                                        <td className='text-center'>{data.async ? "Yes" : "No"}</td>
                                                        <td className='text-center'>{formatDateNew(data?.creationDate)}</td>
                                                        <td className='text-center'><button className='btn' style={{ background: "#337ab7", color: '#fff' }} onClick={() => closeTestingPopup(true, data)}>Test</button></td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-edit" onClick={() => handlePage('add', data)}></i></td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-trash" onClick={() => handleDelete(data)}></i></td>
                                                    </tr>
                                                )) : ""}
                                            </tbody>
                                        </table>
                                        <div style={{ float: "right", marginTop: '20px' }}>
                                            <Pagination
                                                count={Math.ceil(listTableData?.length / itemsPerPage)}
                                                page={currentPage}
                                                onChange={handlePagePagination}
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>}


                        </div>
                        : ""}


                    {viewType === 'add' ?
                        <div className="col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="shadow" style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,.2)', padding: '15px', borderRadius: '6px' }}>
                                <h4 style={{ marginTop: '10px', fontSize: '16px' }}><b>Configure Whatsapp Template</b></h4>
                                <hr style={{ color: '#c7c8c9', borderTop: '3px solid #c7c8c9' }} />


                                <div className="row" style={{ marginTop: '40px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>DLT Id</label>
                                        <input type='text' className='form-control' value={objectData?.dltId} onChange={(e) => handleAddchange(e, "dltId")} />


                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Subject</label>
                                        <input type='text' className='form-control' value={objectData?.whatsappSubject} onChange={(e) => handleAddchange(e, "whatsappSubject")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            <label>Is Async ?</label>
                                            <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                <label class="switch">
                                                    <input type="checkbox" class="checkbox"
                                                        checked={objectData.async}
                                                        onChange={(e) =>
                                                            setObjectData((prev) => ({
                                                                ...prev,
                                                                async: e.target.checked,
                                                            }))
                                                        }
                                                    />
                                                    <div class="slider"></div>
                                                </label>
                                            </div>
                                        </div>
                                        <div>
                                            <label>Is Header ?</label>
                                            <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                <label class="switch">
                                                    <input type="checkbox" class="checkbox"
                                                        checked={objectData.media}
                                                        onChange={(e) =>
                                                            setObjectData((prev) => ({
                                                                ...prev,
                                                                media: e.target.checked,
                                                                mediaPath: "",
                                                                mediaType: "",
                                                            }))
                                                        }
                                                    />
                                                    <div class="slider"></div>
                                                </label>
                                            </div>
                                        </div>
                                        <div>
                                            <label>Is Attachement ?</label>
                                            <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                                <label class="switch">
                                                    <input type="checkbox" class="checkbox"
                                                        checked={objectData.attachment}
                                                        onChange={(e) =>
                                                            setObjectData((prev) => ({
                                                                ...prev,
                                                                attachment: e.target.checked,
                                                                attachmentUrl: ""
                                                            }))
                                                        }
                                                    />
                                                    <div class="slider"></div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row" style={{ marginTop: '30px' }}>
                                    <div className="col-sm-6 col-xs-12">
                                        <label style={{ display: 'inline-flex', alignItems: 'center' }}>
                                            Text&nbsp;
                                            <CustomTooltip title={`Note: Enter Placeholder between {{ }} brackets`} >
                                                <InfoIcon style={{ cursor: 'pointer' }} />
                                            </CustomTooltip>
                                        </label>
                                        <textarea type='text' className='form-control' value={objectData?.whatsappText} onChange={(e) => handleAddchange(e, "whatsappText")} />

                                    </div>
                                    <div className="col-sm-6 col-xs-12">
                                        <label>Description</label>
                                        <textarea type='text' className='form-control' value={objectData?.whatsappDescription} onChange={(e) => handleAddchange(e, "whatsappDescription")} />

                                    </div>

                                </div>
                                <div className="row" style={{ marginTop: '30px' }}>
                                    <div className="col-sm-6 col-xs-12">
                                        <label>Message Type</label>
                                        <select className='form-control' value={objectData?.messageType} onChange={(e) => handleAddchange(e, "messageType")}>
                                            <option value={""}>Select Option</option>
                                            <option value={"template"}>Template</option>
                                            <option value={"text"}>Text</option>
                                            <option value={"image"}>Image</option>
                                        </select>

                                    </div>
                                    <div className="col-sm-6 col-xs-12">
                                        <label>Receiver Type</label>
                                        <select className='form-control' value={objectData?.receiverType} onChange={(e) => handleAddchange(e, "receiverType")}>
                                            <option value={""}>Select Option</option>
                                            <option value={"customer"}>Customer</option>
                                            <option value={"agent"}>Agent</option>
                                            <option value={"dealer"}>Dealer</option>
                                            <option value={"co-borrower"}>Co-Borrower</option>
                                            <option value={"guarantor"}>Guarantor</option>
                                        </select>

                                    </div>
                                </div>

                                {
                                    objectData.media == true ?
                                        <div className="row" style={{ marginTop: '30px' }}>
                                            <>
                                                <div className="col-sm-6 col-xs-12">
                                                    <label>Header Path</label>
                                                    <input type='text' className='form-control' value={objectData?.mediaPath} onChange={(e) => handleAddchange(e, "mediaPath")} />
                                                </div>
                                                <div className="col-sm-6 col-xs-12">
                                                    <label>Header Type</label>
                                                    <select type='text' className='form-control' value={objectData?.mediaType} onChange={(e) => handleAddchange(e, "mediaType")} >
                                                        <option value={""}>Select Option</option>
                                                        <option value={"image"}>Image</option>
                                                        <option value={"video"}>Video</option>
                                                        <option value={"document"}>Document</option>
                                                    </select>
                                                </div>
                                            </>
                                        </div>
                                        : ''}
                                {
                                    objectData.attachment == true ?
                                        <div className="row" style={{ marginTop: '30px' }}>
                                            <div className="col-sm-6 col-xs-12">
                                                <label>Attachment Url</label>
                                                <input type='text' className='form-control' value={objectData?.attachmentUrl} onChange={(e) => handleAddchange(e, "attachmentUrl")} />
                                            </div>
                                        </div>
                                        : ''}



                                <div className="row" style={{ marginTop: '30px' }}>
                                    <div className="col-xs-12 text-center">
                                        <button className='btn' style={{ padding: '10px 15px', borderRadius: '6px', background: '#337ab7', color: '#fff' }} onClick={(e) => handleSave(e)}>Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        : ""}


                    {
                        TestTemplate?.show ?
                            <div className="background-blur">

                                <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                                    <i onClick={() => closeTestingPopup(false, "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                    <div className="row from-group">
                                        <div className="col-xs-12" style={{ padding: '10px' }}>
                                            <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Test Whatsapp Template</h4>
                                        </div>
                                    </div>

                                    <div className="row from-group">
                                        {
                                            TemplateObj && Object.keys(TemplateObj)?.length > 0 ?
                                                Object.keys(TemplateObj)?.map((value, i) => {
                                                    return (
                                                        <div className="col-xs-4 col-xs-12" style={{ marginTop: '15px' }}>
                                                            <label htmlFor="">{value === "mobileNumber" ? value : value}</label>
                                                            <input className='form-control' placeholder={`Enter ${value === "mobileNumber" ? value : value}`} type="text" value={TemplateObj?.[value]} onChange={(e) => handleTemplateObjChnage(e, value)} />
                                                        </div>
                                                    )
                                                })
                                                : ''}

                                    </div>

                                    <div className="row from-group text-center" style={{ marginTop: '20px' }}>
                                        <div className="col-xs-12">
                                            <button onClick={() => HandleSendTest()} disabled={TemplateObj?.mobileNumber == null || TemplateObj?.mobileNumber == undefined || TemplateObj?.mobileNumber == undefined ? true : false} className="btn " style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', color: '#fff', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }}>Send</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""}
                </div>


            </div>
        </>
    )
}

export default Email;
